import { defineMessages } from 'react-intl';

export const layoutSwitcherMessages = defineMessages({
  grid: { id: 'gridSwitcher.grid', defaultMessage: 'Grid' },
  list: { id: 'gridSwitcher.list', defaultMessage: 'List' },
  select: { id: 'gridSwitcher.select', defaultMessage: 'Select {size} view' },
});
